/** Which of the two one column's button is, and whether it can be clicked. */
export interface SelectionAction {
  action: 'select' | 'deselect'
  disabled: boolean
}

/**
 * What a candidate column's one button does, from the two numbers it has to
 * work with: everything the column lists but the memo has not taken, and
 * everything the memo holds from the column whether it is listed or not.
 *
 * Selecting wins while there is anything left to select, so a column half
 * picked offers the rest rather than flipping to a clear nobody asked for -
 * which is what keeps "narrow the filter, take the batch, widen it, take the
 * next" working. Clearing is what is left when adding can do nothing.
 *
 * A column with nothing either way keeps the constructive label, disabled: an
 * empty column reading "Avmarkera alla" would say the wrong thing about a memo
 * whose items the current filter happens to hide.
 */
export function selectionAction(unpicked: number, picked: number): SelectionAction {
  if (unpicked > 0) {
    return { action: 'select', disabled: false }
  }

  if (picked > 0) {
    return { action: 'deselect', disabled: false }
  }

  return { action: 'select', disabled: true }
}
